import UserTagsPanelClient from './UserTagsPanelClient';

export default UserTagsPanelClient;
